export const javascriptSdkSearchIndex = [
	{
		section: 'javascriptSdk',
		title: 'Including the SDK',
		path: '/javascript-sdk',
		summary: `All methods and URLs used by the VoiceStorm JavaScript SDK are HTTPS only. The SDK can be found at /v1/voicestorm.js of your community. For example, if your community’s hostname is sample.api.voicestorm.com, then the SDK URL is https://sample.api.voicestorm.com/v1/voicestorm.js
To include the VoiceStorm SDK on your page, we recommend using the following snippet immediately before the closing </body> tag
loads the SDK asynchronously
VoiceStorm SDK searches the DOM for VoiceStorm widgets via data-voicestorm attributes
Supported Browsers latest versions of Firefox, Chrome, and IE9+. Technically, it should work in any browser that implements localStorage for persistence and either CORS or postMessage for cross-domain requests
SDK internally uses jQuery promise objects`,
		fields: 'VoiceStormAsyncInit sample.api.voicestorm.com getElementsByTagName getElementById insertBefore head'
	},
	{
		section: 'javascriptSdk',
		title: 'Environment',
		path: '/javascript-sdk/environment',
		summary: `VoiceStorm JavaScript SDK creates an environment you can customize.
VoiceStorm Global Object
The VoiceStorm JavaScript SDK exposes one global JavaScript variable: VoiceStorm.
All functionality is either exposed as a function or property of VoiceStorm or as a jQuery widget.
The global VoiceStorm object is not guaranteed to be available until after VoiceStormAsyncInit() has been called.
This is similar to fbAsyncInit in the Facebook JavaScript SDK.
window.name of popup windows used for social media authentication (see the Social Login section)
An ISO 8601time zone designator indicating the local timezone
Coordinated Universal Time (UTC). '-08:00' indicates Pacific Standard Time
An IANA time zone name indicating the local timezone set for the community. Use this name with 3rd party JavaScript libraries like Moment Timezone to convert times returned by JavaScript APIs (which are also in UTC) to local community time.
A list of social providers that support reactions, like Comment, Share, and Like.
This list is provided as a convenient way to determine if a particular provider, such as Facebook, supports reactions. To get detailed information about all the providers available in the community and the reactions they support, call VoiceStorm.api('GET', 'providers'). See GET /v1/providers for more details.
VoiceStorm.jQuery VoiceStorm.host() VoiceStorm.build() VoiceStorm.version() v1
VoiceStorm.defaults
VoiceStorm.defaults.channelUrl
VoiceStorm.defaults.dataPrefix
VoiceStorm.defaults.shareButtonText
VoiceStorm.defaults.shareButtonClass
VoiceStorm.defaults.socialPopupName
VoiceStorm.defaults.submitButtonClass
VoiceStorm.defaults.timeout
VoiceStorm.defaults.timezoneOffset
VoiceStorm.defaults.timezoneIanaName
VoiceStorm.defaults.reactionProviders`,
		fields: 'VoiceStormAsyncInit VoiceStorm authentication defaults jQuery host build version window name AJAX css Facebook Twitter YouTube'
	},
	{
		section: 'javascriptSdk',
		title: 'Promise Objects',
		path: '/javascript-sdk/promise',
		summary: `Other than the utility functions, all methods of the global VoiceStorm object are asynchronous and return jQuery promise objects.
This allows you to easily chain or combine VoiceStorm SDK functions. Here are a few examples
Chaining This example first gets the currently logged on user and then the user’s affiliations
VoiceStorm.currentUser().then VoiceStorm.affiliations console.log
Combining
This example waits for the results of two simultaneous calls.
Assuming there is a leaderboard with an id of 10, the first request is for the ranked users of the leaderboard,
and the second request is for the details of leaderboard 10.
Only after both calls succeed will the success handler be called. If either fail, the error handler is triggered.
VoiceStorm.leaderboardRankings VoiceStorm.leaderboard
`,
		fields: 'when then VoiceStorm currentUser leaderboardRankings leaderboard affiliations function rankings console log'
	},
	{
		section: 'javascriptSdk',
		title: 'Error Objects',
		path: '/javascript-sdk/error',
		summary: `When VoiceStorm SDK functions fail, the promise object's error handler is called. The error object has two properties:
already_exists
invalid_endpoint
invalid_response
invalid_request
login_failed
network_timeout
network_unknown
not_enabled
not_found
not_logged_in
offline
server_error
success
unauthorized
messages An array of human readable strings describing the error.`,
		fields: 'already exists endpoint response request login failed network timeout unknown not enabled found logged server error'
	},
	{
		section: 'javascriptSdk',
		title: 'User Authentication and Security',
		path: '/javascript-sdk/auth',
		summary: `User Authentication and Security
Regardless of whether your pages are HTTP or HTTPS, all AJAX calls made by the VoiceStorm SDK are done over HTTPS.
authenticate user call VoiceStorm.login().
This call will return an authentication token which the VoiceStorm SDK will store in localStorage.
localStorage is used to persist state rather than cookies because your VoiceStorm community is subject to restrictive third-party cookie enforcement.
not call localStorage.clear inadvertently change the state of the VoiceStorm SDK.
Browser same-origin rules apply to localStorage, all of your pages hosted same domain served protocol
recommended host all pages on your site HTTPS
Social Login and Channel Registration
Making calls which authenticate against social networks, VoiceStorm.socialLogin required set channel URL
assigning URL VoiceStorm.defaults.channelUrl. coordinate results running website
Widget popup windows iframe X-Frame-Options HTTP header explicitly allow
contents single line html file pointing
script src https://sample.api.voicestorm.com/v1/voicestorm.js
replace hostname`,
		fields: 'sample api v1 js login clear storage socialLogin'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.changePassword()',
		path: '/javascript-sdk/reference#reference-changePassword',
		summary: `Allows the currently logged in user to change his password. Returns a promise object. The success handler will be passed a successResponse.`,
		fields: 'currentPassword newPassword'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.currentUser()',
		path: '/javascript-sdk/reference#reference-currentUser',
		summary: `Requests the currently logged in user. Returns a promise object. The success handler will be passed a GET /v1/user response. If the user is not currently logged on, the error handler will be called.`,
		fields: ''
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.geos()',
		path: '/javascript-sdk/reference#reference-geos',
		summary: `Requests the list of defined countries, provinces, and states. Returns a promise object. The success handler will be passed a GET /v1/utility/geos response.`,
		fields: ''
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.leaderboard()',
		path: '/javascript-sdk/reference#reference-leaderboard',
		summary: `Requests the details of a specific leaderboard. Returns a promise object. The success handler will be passed a GET /v1/leaderboard response.`,
		fields: 'id'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.leaderboardRankings()',
		path: '/javascript-sdk/reference#reference-leaderboardRankings',
		summary: `Requests the rankings of a specific leaderboard. Returns a promise object. The success handler will be passed a GET /v1/leaderboard/{id}/rankings response.`,
		fields: 'id skip take include images sortMode'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.login()',
		path: '/javascript-sdk/reference#reference-login',
		summary: `Logs a user in. The VoiceStorm SDK will persist the logged in user's session until it expires or VoiceStorm.logout() is called. Returns a promise object. The success handler will be passed a GET /v1/user response representing the logged in user.`,
		fields: 'email password'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.loginWithToken()',
		path: '/javascript-sdk/reference#reference-loginWithToken',
		summary: `Logs a user in with token and expiration from a POST /v1/login response. The VoiceStorm SDK will persist the logged in user's session until it expires or VoiceStorm.logout() is called. Returns a promise object. The success handler will be passed a GET /v1/user response representing the logged in user.`,
		fields: 'token expiration'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.logout()',
		path: '/javascript-sdk/reference#reference-logout',
		summary: `Logs out a currently logged in user. Returns a promise object. The success handler will always be called, but passed nothing.`,
		fields: ''
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.post()',
		path: '/javascript-sdk/reference#reference-post',
		summary: `Requests a specific post. Returns a promise object. The success handler will be passed a GET /v1/post response.`,
		fields: 'id'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.postUrl()',
		path: '/javascript-sdk/reference#reference-postUrl',
		summary: `Given a GET /v1/post response, return a permalink to the post. This returns a string, not a promise object!`,
		fields: 'post'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.profileUrl()',
		path: '/javascript-sdk/reference#reference-profileUrl',
		summary: `Given a user id, return a permalink to the user's profile. This returns a string, not a promise object!`,
		fields: 'id'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.putUser()',
		path: '/javascript-sdk/reference#reference-putUser',
		summary: `Update properties of a user. Returns a promise object. The success handler will be passed a GET /v1/user response.`,
		fields: 'user'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.reactToPost()',
		path: '/javascript-sdk/reference#reference-reactToPost',
		summary: `Shows the user interface to react to a specific post. Returns a promise object.
The reactToPost method is a specialized version of sharePost.
It accepts all the same options as sharePost, plus an additional parameter specific to reactions.
See sharePost for a description of how to customize the reactToPost user interface.
/v1/post/{id}/reaction/{reactionType} request property.
Call VoiceStorm.api('GET', 'providers') to get a list of providers available in the community and the reactionTypes they support.
See GET /v1/providers`,
		fields: 'id reactionType'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.reportPostViewEvent()',
		path: '/javascript-sdk/reference#reference-reportPostViewEvent',
		summary: `Records a post view in the reporting system. Use this on a single article view page to enable article view tracking. Returns a promise object. The success handler will be passed a successResponse.`,
		fields: 'id'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.sharePost()',
		path: '/javascript-sdk/reference#reference-sharePost',
		summary: `Shows the user interface to share a specific post. Returns a promise object. If the user is not currently logged on, the error handler will be called. By default, the share user interface is shown in a browser popup window. Because a popup window is shown, sharePost should only be called in response to a user click event; otherwise a user popup blocker may block the new window.
To show the share user interface inside your own container, such as a Bootstrap modal, use the lightboxContainer option and handle sharePost events.
jQuery selector for an element that will contain the sharing user interface instead of a browser popup window. This element is typically a <div> with no content. sharePost will empty the contents of this element each time the sharing user interface is displayed. See Using a Lightbox, below, for details. Although either option may be used, typically one passes lightboxContainer in the options object, or sets VoiceStorm.defaults.shareDialogLightboxContainer to apply this value globablly
optional fully-qualifed (absolute) secure URL to a stylesheet to apply to the sharing user interface. The user interface always appears on a secure page, so this URL must also be secure (https) or it will be ignored. See Styling the User Interface, below, for details. Although either option may be used, typically one passes cssUrl in the options object, or sets VoiceStorm.defaults.shareDialogCssUrl to apply this value globablly
Using a Lightbox
By default, the sharing user interface opens in a browser popup window.
change this behavior by setting lightboxContainer to an element on your page,
such as a div inside a dialog, like a Bootstrap modal.
Handle events sent by sharePost to show and hide your lightbox and update your page when a share takes place.
When lightboxContainer is set, sharePost will communicate to that element using jQuery events.
Your event handlers will show and hide your lightbox and react to sharing actions as they occur.
Each event is namespaced to the VoiceStorm Javascript SDK and sharePost method.
Register your event handlers different jQuery instance than your page.
show.voicestorm.sharepost
shown.voicestorm.sharepost
authenticated.voicestorm.sharepost
shared.voicestorm.sharepost
closed.voicestorm.sharepost
Sharing Bootstrap Modal share-modal modal fade modal-dialog modal-content modal-header
button close data-dismiss modal-title id myModalLabel Share a Post
share-modal-loading share-modal-sharepost-container modal-body
Styling the User Interface
The share dialog uses CSS classes for styling.
root class is voicestorm-share-dialog. To override these classes in your own stylesheet
set the shareDialogCssUrl property in VoiceStorm.defaults or cssUrl in the options object passed to VoiceStorm.sharePost for details.`,
		fields: 'id postId lightboxContainer shareDialogLightboxContainer cssUrl shareDialogCssUrl show shown authenticated shared closed body dialog title container'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.socialLogin()',
		path: '/javascript-sdk/reference#reference-socialLogin',
		summary: `Shows the user interface to login via a specific social provider. Returns a promise object. The success handler will be passed a GET /v1/user response representing the newly logged in user. The VoiceStorm SDK will persist the logged in user's session until it expires or VoiceStorm.logout() is called. In most cases, this will show a 3rd party Oauth dialog as a popup window. Because a popup window is required, this should only be called in response to a user click event; otherwise a user popup blocker may block the new window.
For this function to succeed, you must include a channel.html file on your site and set VoiceStorm.defaults.channelUrl to point to that file. See Social Login and Channel Registration for details.
canonicalName of a social provider that supports login, such as "Facebook". To get a list of social providers that support login, call VoiceStorm.socialProviders('LoginRegistration'). providerName is case-sensitive`,
		fields: 'providerName'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.socialProviders()',
		path: '/javascript-sdk/reference#reference-socialProviders',
		summary: `Requests a list of available social providers. Returns a promise object. The success handler will be passed a GET /v1/providers response.`,
		fields: 'type AddChannel LoginRegistration'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.stream()',
		path: '/javascript-sdk/reference#reference-stream',
		summary: `Requests the posts in a specific stream. Returns a promise object. The success handler will be passed a GET /v1/stream response.`,
		fields: 'name skip take include content images idsOnly'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.updateUserNotificationPreferences()',
		path: '/javascript-sdk/reference#reference-updateUserNotificationPreferences',
		summary: `Update a user's notification preferences. Returns a promise object. The success handler will be passed a successResponse.`,
		fields: 'preferences'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.user()',
		path: '/javascript-sdk/reference#reference-user',
		summary: `Requests details of a specific user. Returns a promise object. The success handler will be passed a GET /v1/user response.`,
		fields: 'id include address affiliations channels images'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.userAddChannel()',
		path: '/javascript-sdk/reference#reference-userAddChannel',
		summary: `Shows the user interface for a user to add a specific social provider account to their profile. Returns a promise object. The success handler will be passed a providerAuthResponse. In most cases, this will show a 3rd party Oauth dialog as a popup window. Because a popup window is required, this should only be called in response to a user click event; otherwise a user popup blocker may block the new window.
For this function to succeed, you must include a channel.html file on your site and set VoiceStorm.defaults.channelUrl to point to that file. See Social Login and Channel Registration for details.`,
		fields: 'providerName'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.userNotificationPreferences()',
		path: '/javascript-sdk/reference#reference-userNotificationPreferences',
		summary: `Requests a user's notification preferences. Returns a promise object. The success handler will be passed a GET /v1/user/{id}/notifications/preferences.`,
		fields: 'id'
	},
	{
		section: 'javascriptSdk',
		title: 'VoiceStorm.userNotificationsResendSmsCode()',
		path: '/javascript-sdk/reference#reference-userNotificationsResendSmsCode',
		summary: `Returns a promise object. The success handler will be passed a successResponse.`,
		fields: 'id smsVerificationCode resend SMS code notification user'
	}
]


// WEBPACK FOOTER //
// ./src/constants/javascriptSdkSearchIndex.js